module.exports = __webpack_public_path__ + "static/media/forgotpassword.354cfa7d.svg";